import React from 'react';
import { Helmet } from 'react-helmet';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

import { Warning } from '../components/layout/alert';
import ThreeColumn from '../components/layout/three-column';
import TwoColumn from '../components/layout/two-column';
import Table from '../components/layout/table';
import { H1, H2, H3, H4, H5, H6 } from '../components/layout/headings';
import { NewTabLink } from '../components/newtablink';
import { SignupForm } from '../components/signup';
import ScrollSpy from '../components/scrollSpy';
import YellowBgWrapper from '../components/content/yellowBgWrapper';
import BlueBgWrapper from '../components/content/blueBgWrapper';
import Profile from '../components/content/profile';
import WideImage from '../components/content/wideImage';
import Tweet from './tweet';
import arrowDecorator from '../images/icons/icon-arrows-decorator.svg';
import yellowDecorator from '../images/icons/yellow_arrows_decorator.svg';
import No from '../images/icons/icon-no.svg';
import Yes from '../images/icons/icon-yes.svg';
import ShowIfPageScrolled from './showIfPageScrolled';
import { AssemblyDistrictFinder as AssemblyFinder } from '../components/districts/voter-guide-assembly-district-finder';

const AssemblyDistrictFinder = (props) => (
  <ShowIfPageScrolled>
    <AssemblyFinder {...props} />
  </ShowIfPageScrolled>
);
const ArrowDecorator = () => <img src={arrowDecorator} className="!my-0" alt="Arrow Decorator" />;
const YellowDecorator = () => <img src={yellowDecorator} className="!my-0" alt="Arrow Decorator" />;
const YesIcon = () => <img src={Yes} alt="Yes" />;
const NoIcon = () => <img src={No} alt="No" />;

const shortcodes = {
  ShowIfPageScrolled,
  AssemblyDistrictFinder,
  Tweet,
  Warning,
  YesIcon,
  NoIcon,
  WideImage,
  YellowBgWrapper,
  BlueBgWrapper,
  Profile,
  YellowDecorator,
  ArrowDecorator,
  ThreeColumn,
  TwoColumn,
  Table,
  NewTabLink,
  ScrollSpy,
  Helmet,
  SignupForm,
  OutboundLink,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
};

export default shortcodes;
